import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import { Observable, of, switchMap} from 'rxjs';
import {OpenBankingService} from "@compiere-ws/services/openbanking/open-banking.service";
import {catchError} from "rxjs/operators";
import {IupicsCookieService} from "@iupics-manager/managers/security-manager/cookies/iupics-cookie.service";

@Injectable({
    providedIn: 'root',
})
export class OpenBankingGuard {
    component = {id: null, recordId: null, type: null, viewData: null};

    constructor(
        private router: Router,
        private openBankingService: OpenBankingService,private cookieService : IupicsCookieService
    ) {
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkCode(next);
    }

    /**
     * @param route it contains url params
     * @param state it contains the url
     * @description

     send the code so it can be added to the db*/
    private checkCode(route: ActivatedRouteSnapshot): Observable<boolean> {
        const data = route.queryParamMap;
        if (data.get('code')) {
            const bankAccountApiConnectionId = this.cookieService.getDecryptedLocalStorage("openbanking_connection_id");
            return this.openBankingService.openBankingConfirmCode(data.get('code'),Number(bankAccountApiConnectionId)).pipe(
                switchMap(res => {
                    if (res && data.get('state')) {
                        this.router.navigateByUrl(data.get('state'));
                        return of(false); // Prevents original route from being activated}
                    }else return of(true);
                }),
                catchError((err) => {
                    console.log(err?.message)
                    if ( data.get('state')) {
                        this.router.navigateByUrl(data.get('state'));
                        return of(false); // Prevents original route from being activated}
                    }else return of(true);})
            );

        }
    }

}
